const CopyIcon = (props: any) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M4 8.89307C4 7.7885 4.89543 6.89307 6 6.89307H13.1429C14.2474 6.89307 15.1429 7.7885 15.1429 8.89307V19.7502C15.1429 20.8548 14.2474 21.7502 13.1429 21.7502H6C4.89543 21.7502 4 20.8548 4 19.7502V8.89307Z'
        stroke='#317FF5'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.0713 17.1071H18.7141C19.8187 17.1071 20.7141 16.2117 20.7141 15.1071V4.25C20.7141 3.14543 19.8187 2.25 18.7141 2.25H11.5713C10.4667 2.25 9.57129 3.14543 9.57129 4.25V6.89286'
        stroke='#317FF5'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default CopyIcon;
